var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLampOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "currentColor"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.26a1.5 1.5 0 0 0 1.5-1.5V5a1.5 1.5 0 1 0-3 0v4.76a1.5 1.5 0 0 0 1.5 1.5zM46.58 17.3a1.51 1.51 0 0 0 1.06-.44L51 13.49a1.49 1.49 0 0 0 0-2.12 1.51 1.51 0 0 0-2.12 0l-3.36 3.37a1.49 1.49 0 0 0 0 2.12c.282.28.662.439 1.06.44zM57.38 28.88h-4.76a1.5 1.5 0 1 0 0 3h4.76a1.5 1.5 0 0 0 0-3zM47.64 43.9a1.5 1.5 0 1 0-2.12 2.1l3.36 3.36a1.53 1.53 0 0 0 1.06.44A1.5 1.5 0 0 0 51 47.26l-3.36-3.36zM16.36 43.9 13 47.26a1.5 1.5 0 0 0 1.06 2.56 1.53 1.53 0 0 0 1.06-.44L18.48 46a1.5 1.5 0 1 0-2.12-2.12v.02zM11.38 28.88H6.62a1.5 1.5 0 1 0 0 3h4.76a1.5 1.5 0 0 0 0-3zM16.36 16.86a1.5 1.5 0 0 0 2.448-.486 1.49 1.49 0 0 0-.328-1.634l-3.36-3.37a1.51 1.51 0 0 0-2.447.486A1.49 1.49 0 0 0 13 13.49l3.36 3.37zM48.46 29a16.52 16.52 0 1 0-27.25 13.88A10.76 10.76 0 0 1 25 51v.7a1.5 1.5 0 0 0 1.5 1.5h.76v2.55a4.74 4.74 0 1 0 9.48 0v-2.54h.76a1.5 1.5 0 0 0 1.5-1.5V51a11 11 0 0 1 3.88-8.21A16.409 16.409 0 0 0 48.46 29zM33.74 55.76a1.74 1.74 0 1 1-3.48 0v-2.55h3.48v2.55z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampOn);
export default __webpack_public_path__ + "static/media/lampOn.640976d077061a68bc58251d20ceb802.svg";
export { ForwardRef as ReactComponent };